import { observable } from "mobx";
import axios from "axios";
import { toast } from "react-toastify";
import { AppStore } from "../AppStore";
import Cookies from 'universal-cookie';
import { GenerateStore } from "../2fa/GenerateStore";
import { api } from "../../api";

const cookies = new Cookies();

export class _LoginStore {
    obs = observable({
        razao_social: "" as string,
        cnpj: "" as string,
        telefone: "" as string,
        cep: "" as string,
        rua: "" as string,
        complemento: "" as string,
        bairro: "" as string,
        numero: "" as string,
        cidade: "" as string,
        estado: "" as string,
        pessoa_nome: "" as string,
        pessoa_rua: "" as string,
        pessoa_cep: "" as string,
        pessoa_bairro: "" as string,
        pessoa_numero: "" as string,
        pessoa_cidade: "" as string,
        pessoa_estado: "" as string,
        pessoa_cpf: "" as string,
        pessoa_nascimeto: "" as string,
        pessoa_email: "" as string,
        termos: false as boolean,
        acomar: false as boolean,
        email: "" as string,
        senha: "" as string,
        conta_id: "" as string,
        login_dados: [] as any,
        byPass: false as boolean,
        representante_id: "" as string,
        isBlock: false as boolean
    })


    async handleCreateConta(params: any) {
        let resp = await axios.post("/public/conta/criar", params)

        return resp.data
    }

    async handleCreateuser(params: any) {
        let resp = await axios.post("/public/conta/usuario/criar", params)

        return resp.data
    }

    async handleGetAutenticacao(codigo: string) {

        let params = {
            codigo: codigo
        }

        let resp = await axios.post("/public/send-autenticar-conta", params)

        return resp.data
    }

    async handleResendToken(email: string) {

        let params = {
            email: email
        }

        let resp = await axios.post("/public/resend-token", params)

        return resp.data
    }

    async handleLogin(params: any) {
        let resp = await axios.post("/public/login/2fa", params);

        if (resp.data.ok) {
            let isOK: boolean = resp.data.ok
            let is2fa: boolean = resp.data["2fa"]
            let isPending2fa: boolean = resp.data["pending_validation"]
            this.obs.byPass = resp.data["by_pass"]

            if (isOK && is2fa && !isPending2fa) {
                cookies.set('goto_2fa', resp.data.token_2fa, { path: '/', maxAge: 3600 });
                return true

            } else {
                return false
            }

        } else {
            toast.error(resp.data.msg, {});
            return false
        }
    }

    async handleLoginNot2fa(email: string, senha: string) {
      
        try {
            let params = {
                email: email,
                password: senha,
                by_pass: this.obs.byPass,
                representante: false,
            }
            let resp = await axios.post("/public/login", params);

            if (resp.data.ok == true) {

                if (this.obs.byPass) {
                    cookies.set('goto', resp.data.token, { path: '/', maxAge: 3600 });
                    cookies.set('goto_socket', resp.data.token_socket, { path: '/', maxAge: 3600 });
                    cookies.set('goto_adm', resp.data.token_adm, { path: '/', maxAge: 3600 });
                    cookies.set('goto_repre', resp.data.token_repre, { path: '/', maxAge: 3600 });

                    window.location.href = resp.data.redirect

                    return false
                } else {
                    this.obs.login_dados = resp.data
                    return true
                }
            }

            if (resp.data.msg.match("E-mail não ativado.")) {
                let ret = await LoginStore.handleResendToken(email)

                if (ret.ok) {
                    LoginStore.obs.email = email

                    AppStore.setLocation("/conta/autenticar");
                    return false
                } else {
                    toast.error("Não foi possível enviar e-mail, tente novamente!", {});
                    return false
                }

            } else {
                toast.error(resp.data.msg, {});
                return false
            }


        } catch (ex) {
            toast.error("Erro na validação do login, por favor tente novamente mais tarde!", {});
        }

    }

    async handleAdmLogin(params: any) {
        let resp = await axios.post("/public/login-adm", params)

        return resp.data
    }

    async handleRecuperaSenha(data: any) {
        let resp = await axios.post("/public/recuperar-senha", data);

        return resp.data
    }

    async handleSalvarSenha(data: any) {
        let resp = await axios.post("/public/salvar-senha", data);

        return resp.data
    }


    async handleGetCep(new_cep: string) {
        let resp = await axios.get(`/public/get-cep/${new_cep}`)

        return resp.data
    }

    async handleValidateCode(code: string, email: string, password: string): Promise<void> {

        try {
            let params = {
                code: code,
                email: email,
                password: password,
                representante: false
            }

            let resp = await axios.post('/2fa/validate', params, { headers: { "X-NZ-Token": cookies.get('goto_2fa') } })

            if (resp.data.ok) {
                cookies.set('goto', resp.data.token, { path: '/', maxAge: 3600 });
                cookies.set('goto_socket', resp.data.token_socket, { path: '/', maxAge: 3600 });
                cookies.set('goto_adm', resp.data.token_adm, { path: '/', maxAge: 3600 });
                cookies.set('goto_repre', resp.data.token_repre, { path: '/', maxAge: 3600 });

                window.location.href = resp.data.redirect;

            } else {

                if (resp.data.msg.match("E-mail não ativado.")) {
                    toast.error(resp.data.msg, {});

                    let ret = await LoginStore.handleResendToken(email)

                    if (ret.ok) {
                        LoginStore.obs.email = email

                        AppStore.setLocation("/conta/autenticar");
                    } else {
                        toast.error("Não foi possível enviar e-mail, tente novamente!", {});
                    }

                } else {
                    toast.error(resp.data.msg, {});
                }

            }

        } catch (ex) {
            toast.error("Erro validando código, tente novamente mais tarde!", {});
        }
    }

    async handleValidateCodeAdmin(code: string, email: string, password: string, token: string): Promise<void> {

        try {
            let params = {
                code: code,
                email: email,
                password: password,
                token: token,
                representante: false
            }

            let resp = await axios.post('/2fa/validate', params, { headers: { "X-NZ-Token": cookies.get('goto_2fa') } })

            if (resp.data.ok) {
                cookies.set('goto', resp.data.token, { path: '/', maxAge: 3600 });
                cookies.set('goto_socket', resp.data.token_socket, { path: '/', maxAge: 3600 });
                cookies.set('goto_adm', resp.data.token_adm, { path: '/', maxAge: 3600 });
                cookies.set('goto_repre', resp.data.token_repre, { path: '/', maxAge: 3600 });

                window.location.href = resp.data.redirect;

            } else {

                toast.error(resp.data.msg, {});

            }

        } catch (ex) {
            toast.error("Erro validando código, tente novamente mais tarde!", {});
        }
    }

  async buscaCNPJ(cnpj: any): Promise<void> {

    try {

      cnpj = (cnpj.match(/\d+/g) || []).join("")

      if(!(cnpj.length == 14)) return 

      let resp = await axios.get(`/public/busca-dados-cnpj/${cnpj}`);

      if(resp.data.ok){

        LoginStore.obs.razao_social = resp.data.razao_social || ""
        LoginStore.obs.cep = resp.data.cep || ""
        LoginStore.obs.rua = resp.data.rua || ""
        LoginStore.obs.complemento = resp.data.complemento || ""
        LoginStore.obs.bairro = resp.data.bairro || ""
        LoginStore.obs.numero = resp.data.numero || ""
        LoginStore.obs.cidade = resp.data.cidade || ""
        LoginStore.obs.estado = resp.data.estado || ""

        if(LoginStore.obs.estado != "PA") this.obs.isBlock = true
        return

      } else {

        toast.error(resp.data.message, {})

      }

    } catch (ex) {}

    LoginStore.obs.razao_social = ""
    LoginStore.obs.cep = ""
    LoginStore.obs.rua = ""
    LoginStore.obs.complemento = ""
    LoginStore.obs.bairro = ""
    LoginStore.obs.numero = ""
    LoginStore.obs.cidade = ""
    LoginStore.obs.estado = ""

  }

}

export const LoginStore = new _LoginStore();
